{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Lataa (v2)"
      }
    }
  },
  "subHeader": {
    "backToMyBookings": "Poistu sivulta",
    "backToMyBookingsAria": "Poistu sivulta"
  },
  "reviewPage": {
    "backButtonTravelExtras": "Lisäpalvelut"
  }
}
